import { combineReducers } from 'redux';
import authReducer from './authReducer';
import errorReducer from './errorReducer';
import profileReducer from './profileReducer';
import clientReducer from './clientReducer';
import participantsReducer from './participantsReducer';
import conferenceReducer from './conferenceReducer';

export default combineReducers({
  auth: authReducer,
  users: participantsReducer,
  conferenceList: participantsReducer,
  errors: errorReducer,
  profile: profileReducer,
  student: profileReducer,
  participant: participantsReducer,
  participants: participantsReducer,
  participants1: participantsReducer,
  conference: conferenceReducer,
  client: clientReducer,
});
